import { type DisplayTheme, type DisplayThemeWithSDG, ImpactLevel } from '@netpurpose/api'
import { getSingleDisplayTheme } from '#utils'

// Order to sort impact levels by:
const themeOrder = [
  ImpactLevel.PRODUCTS_SERVICES,
  ImpactLevel.OPERATIONS,
  ImpactLevel.VALUE_CHAIN,
  null,
]

type ValueHolder = { value?: number | null | undefined }

const allEntriesHaveValue = (data: {
  companies?: Record<string, ValueHolder> | null
  portfolios?: Record<string, ValueHolder> | null
}) => {
  const entries = [...Object.values(data.companies || {}), ...Object.values(data.portfolios || {})]
  return entries.length > 0 && entries.every((entry) => entry.value != null)
}

export const sortQuestionsOrImpactByTheme = <
  Data extends {
    displayThemes: (DisplayThemeWithSDG | DisplayTheme)[] | undefined | null
    impactLevel?: ImpactLevel | undefined | null
    displayPriority?: number | null
    isSdgRevenueHeader?: boolean
    companies?: Record<string, ValueHolder> | null
    portfolios?: Record<string, ValueHolder> | null
  },
>(
  data?: Data[],
) =>
  data?.sort((a, b) => {
    const aTheme = getSingleDisplayTheme(a.displayThemes || undefined) || ''
    const bTheme = getSingleDisplayTheme(b.displayThemes || undefined) || ''
    return (
      (aTheme === 'SDG' ? 1 : 0) - (bTheme === 'SDG' ? 1 : 0) || // Want SDG theme to come last
      // Items where all companies/portfolios have a value come first
      (allEntriesHaveValue(b) ? 1 : 0) - (allEntriesHaveValue(a) ? 1 : 0) ||
      themeOrder.indexOf(a.impactLevel || null) - themeOrder.indexOf(b.impactLevel || null) ||
      aTheme.localeCompare(bTheme) ||
      (a.displayPriority || 0) - (b.displayPriority || 0)
    )
  })
